module.exports = __webpack_public_path__ + "assets/img/hide.d4939e3e.svg";